
let auth_pass = generateRandStr(15); // pass the length of random generated string
let authkey = 'Basic ' + btoa("H2OH2SO4OOHCH4H2O2:" + auth_pass);

export const environment = {
  production: true,
  apiUrl: 'https://api.docquity.com/',
  oldApiUrl: 'https://docquity.com/',
  journalApiUrl: 'https://journals.docquity.com/',
  appKey: 'Basic OUFASSRTUjYhUCQwI0lANT9TQDg/SDo=',
  appVersion: '1000',
  releaseVersion: 'V 1.0',
  deviceType: 'web',
  webUrl: 'https://app.docquity.com',
  hashKey: '@lb3rt!Th0m@52310n3$r!n!v@s@R@m@nuj@n',
  immunityKey: 'D0ct0r0p3r@t!0nC3nt3rQu35t!0nUNity',
  webSiteUrl: 'https://docquity.com',
  device_info: '',
  jwtSecretKey: 'zkbzRk11dSbaQjGTDRcw8yhInNFIyl6MHLZOISPwWy2DR5kqGuuaXvzU6qxCUUjIp1WBWNcGn6zsXy7kiptLsENH5cVOyRpFTOgG',
  api_debugger: 0,          // 0 for off and 1 for on
  ngxs_data_reset_time: 1,  //time in minutes
  CrossStorageClient: 'https://app.docquity.com',

  local_nav: [
    { id: 1, url: '/web', value: 'gr', module_name: 'Web Trends', menu_icon: 'icon-home' },
    { id: 2, url: '/cme', value: 'cme', module_name: 'Cme', menu_icon: 'icon-cpd' },
    { id: 8, url: '/journal', value: 'journal', module_name: 'Journal', menu_icon: 'icon-cme' },
    { id: 9, url: '/channel/detail/0', value: 'channel', module_name: 'Channel', menu_icon: 'icon-channel' },
    { id: 4, url: '/refer-and-earn/referal', value: 'rewards', module_name: 'refer-and-earn', menu_icon: 'icon-channel3' },
    { id: 28, url: '/connection/suggestion', value: 'connection', module_name: 'connection', menu_icon: 'icon-connection' }
  ]
};

function generateRandStr(length) {
  var randomString;
  var text = "";
  var possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  for (var i = 0; i < length; i++) {
    text += possible.charAt(Math.floor(Math.random() * possible.length));
  }
  return text;
}
